import React, { useState, useEffect, use, useCallback } from "react";
import {
  Tabs,
  Tab,
  IconButton,
  Box
} from "@mui/material";
import { FiX } from "react-icons/fi";
import './DetailedTicketView.css'
import API_BASE_URL from "./RestAPI";
import { showSuccessToast, showErrorToast } from "../constants/ToastService.js";
import LiveMovePanel from "./LiveMovePanel.js";

const tabStyle = {
  textTransform: "capitalize",
  fontSize: "14px",
  fontWeight: 500,
  color: "#aaa",
  "&:hover": {
    color: "#fff",
  },
  "&.Mui-selected": {
    color: "#fff",
  },
};

const DetailedTicketView = ({ ticketID, ticketId, open, onClose }) => {
  // Callers pass either `ticketID` (Sprints.js) or `ticketId` (SprintDashboard.js).
  ticketID = ticketID ?? ticketId;
  console.log("DetailedTicketView ticketID:", ticketID);
  const [activeTab, setActiveTab] = useState(0);
  const [reportData, setReportData] = useState(null);
  const [timelineEvents, setTimelineEvents] = useState([]);
  const [childTickets, setChildTickets] = useState([]);
  const [bugTickets, setBugTickets] = useState([]);

  const getReportData = useCallback(async (ticketID) => {
      try {
          return fetch(`${API_BASE_URL}reports/ticket/detailed/view/?ticket_id=${ticketID}`,
              {
                  method: "GET",
                  headers: {
                      "Content-Type": "application/json",
                      'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                  }
              })
              .then((res) => res.json())
              .then((data) => {
                  if (data.status === "success") {
                      setReportData(data.data); 
                      setTimelineEvents(data.timeline || []);
                      setChildTickets(data.child_tickets || []);
                      setBugTickets(data.bug_tickets || []);                            
                  } else {
                      showErrorToast(data.message);
                  }
              })
              .catch((err) => {
                  console.error(err.message);
                  return [];
              });
      } catch (err) {
          console.error(err);
          showErrorToast("Failed to fetch tickets");
      }
  }, []);

  const buildTimelineEvents = (timeline) => {
    if (!timeline) return [];

    const events = [];

    Object.entries(timeline).forEach(([time, data]) => {
      // Ticket created
      if (typeof data === "string") {
        events.push({
          time,
          type: "created",
          title: "Ticket Created",
          description: data,
        });
        return;
      }

      // Status changes
      if (data.status_changed_to?.length){
        data.status_changed_to.forEach((s) => {
          events.push({
            time,
            type: "status",
            title: `Ticket ${s.ticket_no} Status Changed`,
            description: `${s.status_changed_from} → ${s.status_changed_to}`,
          });
        });
      }

      // Bugs raised
      if (data.bugs_raised?.length) {
        data.bugs_raised.forEach((s) => {
          events.push({
            time,
            type: "bug",
            title: `Bug Raised against ${s.ticket_no}`,
          });
        });
      }

      // Move to Sprint
      if (data.sprint_moved?.length){
        data.sprint_moved.forEach((s) => {
          events.push({
            time,
            type: "move to sprint",
            title: `Ticket ${s.ticket_no} Moved to Another Sprint`,
            description: `${s.from_sprint} → ${s.to_sprint}`,
          });
        });
      }

    });

    // Sort latest first
    return events.sort(
      (a, b) => new Date(b.time) - new Date(a.time)
    );
  };


  useEffect(() => {
    if (ticketID) {
        getReportData(ticketID);
    } else {
        setReportData([]);
        setTimelineEvents([]);
        setChildTickets([]);
        setBugTickets([]);  
    }
  }, [ticketID]);

  return (
    <div className="detail-popup-overlay" onClick={onClose}>
      <div
        className="detail-popup-content"
        onClick={(e) => e.stopPropagation()} // prevent close
      >
        {/* Header */}
        <div className="detail-popup-header">
          <h1>Detailed View</h1>
          <IconButton onClick={onClose}>
            <FiX />
          </IconButton>
        </div>

        {/* Tabs */}
        {/* <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)}>
            {/* <Tab label="Ticket Details" sx={tabStyle} /> */}
            {/* <Tab label="Child Tickets" sx={tabStyle} />
            <Tab label="Bug Tickets" sx={tabStyle} />
            <Tab label="Ticket Report" sx={tabStyle} /> */}
        {/* </Tabs> */}

        {/* Content */}
        <Box className="detail-popup-body">
          {activeTab === 0 && 
            <div className="ticket-report-container">
              <div className="ticket-report-header">
                <div>
                  <h2>{reportData?.parent_code || reportData?.child_code || reportData?.bug_code} [ {reportData?.ticket_type} ]</h2>
                  <p className="ticket-title">{reportData?.short_description}</p>
                </div>

                <div className="ticket-meta" style={{ fontSize: '20px' }}>
                  <span className="badge status">{reportData?.sts}</span>
                  <span className="badge priority">{reportData?.priority_name}</span>
                </div>
              </div>
              <br></br>
              <div className="timeline-section">
                <h3>Ticket Timeline</h3>

                <ul className="timeline">
                  {buildTimelineEvents(timelineEvents).map((event, index) => (
                    <li key={index} className={`timeline-item ${event.type}`}>
                      <div className="timeline-dot" />

                      <div className="timeline-content">
                        <p className="time-title">{event.title}</p>
                        <p className="time-desc">{event.description}</p>
                        <span className="time-time">{event.time}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <LiveMovePanel
                ticketId={ticketID}
                ticketStatusName={reportData?.sts}
              />

            </div>
          }

          {/* {activeTab === 1 && <ChildTickets data={ticketData.childTickets} />}
          {activeTab === 2 && <BugTickets data={ticketData.bugTickets} />}
          {activeTab === 3 && <TicketReport data={reportData} />} */}
        </Box>
      </div>
    </div>
  );
};

export default DetailedTicketView;